<template>
  <section class="link-section" v-if="$store.state.links && $store.state.links.length">
    <div class="link-section__container">
      <ul class="link-section__row">
        <li class="link-section__column" v-for="(link, index) in $store.state.links" :key="index">
          <a :href="link.url" target="_blank" rel="nofollow" class="link" :title="link.title || 'нет названия'" :aria-label="link.title || 'нет названия'">
            <img class="link__icon" :src="getSrc(link)" :alt="link.title || 'нет названия'" :title="link.title || 'нет названия'">
            <span class="link__title">{{ link.title }}</span>
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>

export default {
  name: 'LinkSection',
  methods: {
    getSrc (item) {
      if (item.img) {
        if (!item.img.startsWith('http')) {
          if (item.media_server_url) {
            return item.media_server_url + item.img
          } else if (item.img) {
            return this.$store.state.api + '/' + item.img
          }
        } else {
          return item.img
        }
      }
      return '/public/img/placeholder.png'
    }
  }
}
</script>
